import { render, staticRenderFns } from "./focusYouth.vue?vue&type=template&id=0f6ce9ea&scoped=true&"
import script from "./focusYouth.vue?vue&type=script&lang=js&"
export * from "./focusYouth.vue?vue&type=script&lang=js&"
import style0 from "./focusYouth.vue?vue&type=style&index=0&id=0f6ce9ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6ce9ea",
  null
  
)

export default component.exports